import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS_Mapper extends BaseFormMapper<CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS);

		return _formData;
	}

	MapValues(): Partial<CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS> {
		return {};
	}
}

const Mappings: CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS =
	{
		// "0":"ButtonSubmit0",
		re: 'Text101',
		annualTaxAmount: 'Text110',
		guarantor: 'Text2',
		signature: 'Text124',
		date: 'Text123',
		faxNumber: 'Text121',
		telephoneNumber: 'Text120',
		lawFirmAddress: 'Text122',
		lawFirmName: 'Text119',
		exceptions: 'Text111',
		trustNumber: 'Text116',
		transitNumber: 'Text115',
		bankName: 'Text50',
		requiredDateFunds: 'Text117',
		requisitionedAmount: 'Text114',
		mortgageAmount: 'Text112',
		roll: 'Text109',
		municipalTaxOfficeName: 'Text108',
		legalDescription: 'Text107',
		propertyAddress: 'Text106',
		mortgagor: 'Text104',
		cibcReferenceNumber: 'Text103',
	};

export interface CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS {
	cibcReferenceNumber: string;
	re: string;
	mortgagor: string;
	guarantor: string;
	propertyAddress: string;
	legalDescription: string;

	municipalTaxOfficeName: string;
	roll: string;
	annualTaxAmount: string;

	mortgageAmount: string;
	requisitionedAmount: string;
	requiredDateFunds: string;

	bankName: string;
	transitNumber: string;
	trustNumber: string;

	exceptions: string;

	lawFirmName: string;
	telephoneNumber: string;
	faxNumber: string;
	lawFirmAddress: string;
	signature: string;
	date: string;
}
